// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TJ1qN","buttons":"styles_buttons__1BkIr"};